import Auth from '@/Apis/Auth'
import Vue from 'vue'
import VueRouter from 'vue-router'
import Pages from './Pages'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },

  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import(/* webpackChunkName:'announcements' */ '../views/Page/Home/Home.vue'),

    },
    ...Pages,
   
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/authentication/Login.vue'),
      meta: {
        layout: 'full',
        notRequiresAuth: true
      },

    },
    //Direct
    {
      path: '/direct/:id',
      name: 'Direct',
      component: () => import(/* webpackChunkName:'Direct' */ '../views/Page/Online/Direct.vue'),
      meta: {
        layout: 'full',
        notRequiresAuth: true
      },
    },
    {
      path: '/meeting/:id',
      name: 'Meeting',
      component: () => import(/* webpackChunkName:'Meeting' */ '../views/Page/Online/VC.vue'),
      meta: {
        layout: 'full',
        notRequiresAuth: true

      },

    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: () => import('../views/authentication/ForgotPassword-v1.vue'),
      meta: {
        layout: 'full',
        notRequiresAuth: true
      },

    }, {
      path: '/reset-password',
      name: 'RersetPassword',
      component: () => import('../views/authentication/ResetPassword-v1.vue'),
      meta: {
        layout: 'full',
        notRequiresAuth: true
      },

    },
    {
      path: '/register',
      name: 'Register',
      component: () => import('../views/authentication/Register.vue'),
      meta: {
        layout: 'full',
        notRequiresAuth: true

      },
    },
    {
      path: '/register-programs/:type',
      name: 'RegisterQuranPrograms',
      component: () => import('../views/authentication/Register.vue'),
      meta: {
        layout: 'full',
        notRequiresAuth: true

      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
        notRequiresAuth: true

      },
    },
    {
      path: '/NotAuthorized',
      name: 'NotAuthorized',
      component: () => import('@/views/error/NotAuthorized.vue'),
      meta: {
        layout: 'full',
        notRequiresAuth: true

      },
    },
    {
      path: '*',
      redirect: 'error-404',
      notRequiresAuth: true

    },
  ],
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen


router.beforeEach(async (to, from, next) => {
  const appLoading = document.getElementById('loading-bg')

  if (appLoading) {
    appLoading.style.display = 'none'
  }

  if (to.matched.some(record => record.meta.notRequiresAuth)) {

    next() // make sure to always call next()!

  } else {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!Auth.AUTHORIZED) {
      next({ name: 'login' })
    } else {
      if (!Auth.PERMISSIONS.includes(to.name) && to.name !== "Home" && to.name !== 'Roles')
        next({ name: 'NotAuthorized' })

      next()
    }
  }
})
export default router
